import { reactive } from 'vue';
import BaseSetupService from '@/setup/BaseSetupService';

type Props = SetupProps<typeof DashboardTempWorkerSetupService.props>

export default class DashboardTempWorkerSetupService extends BaseSetupService<Props> {
	static readonly props = undefined;

	private readonly state = reactive({
		showCurrentContract: true,
		showMessageAgency: true,
		showSalaryCurrentYear: true,
		showProfileCompletion: true,
		// showMarketingCodeCard: false,
		elem: document.getElementById('temp-worker-calendar'),
	});

	get showCurrentContract () { return this.state.showCurrentContract; }
	get showMessageAgency () { return this.state.showMessageAgency; }

	get showSalaryCurrentYear () { return this.state.showSalaryCurrentYear; }
	set showSalaryCurrentYear (val) { this.state.showSalaryCurrentYear = val; }

	get showProfileCompletion () { return this.state.showProfileCompletion; }
	set showProfileCompletion (val) { this.state.showProfileCompletion = val; }

	// get showMarketingCodeCard () { return this.state.showMarketingCodeCard; }
	get elem () { return this.state.elem; }
	get teleportComponent () { return this.ui.onLayoutNoAside ? '#temp-worker-calendar' : '#right-aside';}

	constructor (props?: Props) {
		super(props);
	}

	protected onMounted () {
		super.onMounted();
		this.state.elem = document.getElementById('temp-worker-calendar');
	}
}
